export const Stat = ({ label, value, cls = "text-slate-50", sub, id }) => (
  <div className="panel px-4 py-3">
    <div className="eyebrow">{label}</div>
    <div data-testid={id} className={`num mt-1 text-xl font-bold tracking-tight sm:text-2xl ${cls}`}>{value}</div>
    {sub && <div className="mt-0.5 text-[11px] text-slate-500">{sub}</div>}
  </div>
);

export const DataAccessNotice = ({ onRecheck }) => (
  <div data-testid="notice-data-subscription" className="panel border-amber-500/30 p-6">
    <div className="eyebrow !text-amber-400">Market data not available on your Dhan plan</div>
    <p className="mt-2 max-w-2xl text-sm text-slate-300">
      Dhan connected successfully, but your account is on the <b>FREE</b> plan (error DH-902). Dhan only provides candles, quotes, the option chain and history through its paid <b>Data API</b> subscription.
      Until it is active, the chart, signals, option chain, spread suggestions, paper trades and backtests cannot load. Funds and positions still work.
    </p>
    <ol className="mt-3 list-decimal space-y-1 pl-5 text-xs text-slate-400">
      <li>Log in at web.dhan.co and open <b>My Profile → DhanHQ Trading APIs</b>.</li>
      <li>Subscribe to <b>Data APIs</b>.</li>
      <li>Generate a new Access Token, paste it in Settings, then click Re-check.</li>
    </ol>
    {onRecheck && (
      <button data-testid="button-recheck-data" onClick={onRecheck} className="mt-4 rounded border border-amber-500/40 px-3 py-1.5 text-xs font-semibold text-amber-300 transition-colors hover:bg-amber-500/10">
        Re-check access
      </button>
    )}
  </div>
);

export const Empty = ({ children, id }) => (
  <div data-testid={id} className="panel flex min-h-[160px] items-center justify-center p-6 text-center text-sm text-slate-500">{children}</div>
);
